"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdBannerAdapter = void 0;
const demarked_1 = require("@d24/demarked");
const adapter_1 = require("../_helpers/adapter");
const _contracts_1 = require("../_contracts");
const AdBanner_contracts_1 = require("./AdBanner.contracts");
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
class AdBannerAdapter {
    /**
     * @inheritDoc
     */
    objectToToken() {
        return {
            content: '$$$',
            raw: '$$$',
            type: demarked_1.TokenType.AdBanner
        };
    }
    /**
     * @inheritDoc
     */
    tokenToObject() {
        return {
            ...adapter_1.getModuleBase(),
            content: {
                autoFetchSiteTags: true,
                doNotShrink: false,
                sizes: [],
                size: AdBanner_contracts_1.AdBannerSize.InText,
                type: AdBanner_contracts_1.AdBannerType.Default
            },
            driver: _contracts_1.ModuleDriver.AdBanner,
            version: AdBanner_contracts_1.AdBannerVersion.GoogleAds
        };
    }
}
exports.AdBannerAdapter = AdBannerAdapter;
//# sourceMappingURL=AdBanner.adapter.js.map